/**
 * ConfigAlerta
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {ResponseSerialize} from 'simpli-web-sdk'
import {Responsavel} from '@/model/resource/Responsavel'
import {ConfigAlertaCollection} from '@/model/collection/ConfigAlertaCollection'

/* TODO: review generated class */
export class ConfigAlerta extends Resource {
  idConfigAlertaPk: number = 0

  @ResponseSerialize(Responsavel)
  responsavel: Responsavel | null = null

  ativo: boolean | null = null

  get $id() {
    return this.idConfigAlertaPk
  }
  set $id(val) {
    this.idConfigAlertaPk = val
  }

  get idResponsavelFk() {
    if (!this.responsavel) return 0
    return this.responsavel.$id
  }
  set idResponsavelFk(val) {
    if (!this.responsavel) this.responsavel = new Responsavel()
    this.responsavel.$id = val
  }

  /**
   * Gets a instance of a given ID of ConfigAlerta
   */
  async getConfigAlerta(id: number) {
    return await Request.get(`/admin/config-alerta/${id}`)
      .name('getConfigAlerta')
      .as(this)
      .getData()
  }

  /**
   * Deletes a instance of a given ID of ConfigAlerta
   */
  async removeConfigAlerta() {
    return await Request.delete(`/admin/config-alerta/${this.$id}`)
      .name('removeConfigAlerta')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of ConfigAlerta
   */
  static async listConfigAlerta(params: any) {
    return await Request.get(`/admin/config-alerta`, {params})
      .name('listConfigAlerta')
      .as(ConfigAlertaCollection)
      .getData()
  }

  /**
   * Persists a new instance of ConfigAlerta. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistConfigAlerta() {
    return await Request.post(`/admin/config-alerta`, this)
      .name('persistConfigAlerta')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of ConfigAlerta to use it in a CSV file
   */
  static async listCsvConfigAlerta(params: any) {
    return await Request.get(`/admin/config-alerta/csv`, {params})
      .name('listCsvConfigAlerta')
      .as(ConfigAlertaCollection)
      .getData()
  }
}
